import React, { useEffect, useState } from "react";
import { Collapse, Divider, Input } from "antd";
import { ChevronDown, ChevronUp } from "lucide-react";
import MultiSelectCheckboxGroup from "../components/BrandsPartnerComponents/multiselect_checkbox";
import { usePartnerOnboarding } from "../../contexts/PartnerOnboardingContext";
import DeleteIconV2 from "../components/BrandsPartnerComponents/DeleteIconV2";
import DeleteConfirmationModal from "../components/BrandsPartnerComponents/Modals/DeleteConfirmationModal";
import { SearchOutlined } from "@ant-design/icons";
import { PartnerMarketType, PartnerType } from "./dtos/partner.dtos";
import SimpleSingleSelectButtonGroup from "../components/BrandsPartnerComponents/SingleSelectRadioButton";
import MultiSelectWithAddItem from "../components/BrandsPartnerComponents/MultiselectComponentWithAddItem";


type ExpansionEdgePageType = {
  data: PartnerType;
  setData: React.Dispatch<React.SetStateAction<PartnerType>>;
};
const ExpansionEdgePage: React.FC<ExpansionEdgePageType> = ({
  data,
  setData,
}) => {
  const { selectedMarkets, setSelectedMarkets } = usePartnerOnboarding();


  const [checkedHealthSuppliments, setCheckedHealthSuppliments] = useState(true);
  const [checkedBeauty, setCheckedBeauty] = useState(true);
  const [checkedFood, setCheckedFood] = useState(true);
  const [otherInputValueFAB, setOtherInputValueFAB] = useState("");
  const [checkedPetNutrition, setCheckedPetNutrition] = useState(true);
  const updateMarketFocusCategory = (
    activeMarket: string,
    category: string,
    subCategories: string[],
    setData: React.Dispatch<React.SetStateAction<PartnerType>>,

  ) => {
    if (!activeMarket) return;
    setData((current) => {
      const newMarkets = new Map(Object.entries(current.markets));
      const currentMarkets = current.markets;
      const existingMarket = newMarkets.get(activeMarket) || {
        focus_categories: {},
        region: 0,
        channel_coverage: [],
        service_capabilities: [],
        warehousing: [],
        engagement_model: [],
        trading_terms: '',
        minimum_tenure: '',
        trade_marketing_investments: '',
        payment_terms: [],
      };

      const updatedFocusCategories = {
        ...existingMarket.focus_categories,
        [category]: subCategories,
      };


      const matchedMarket = selectedMarkets.find((m) => m.name === activeMarket);
      const regionId = Number(matchedMarket?.id ?? 0);

      newMarkets.set(activeMarket, {
        ...existingMarket,
        focus_categories: updatedFocusCategories,
        region: regionId,
      });

      console.log("Updated Markets:", Array.from(newMarkets.entries())); // good for debugging

      return {
        ...current,
        markets: {
          ...currentMarkets,
          [activeMarket]: {
            ...existingMarket,
            region: regionId,
            focus_categories: updatedFocusCategories,
          },
        },
      };
    });
  };
  const [serviceScope, setServiceScope] = useState<any>({
    healthSupplements: [],
    beautyAndSkin: [],
    foodAndBeverages: [],
    petNutrition: [],
    keyChannelCoverage: [],
    keyCapabilities: [],
    warehousing: [],
    acceptedBusinessModels: [],
    tradingTerms: [],
    minimumExclusivityTenure: [],
    preferenceonMarketingInvestment: [],
    paymentTerms: [],
  });


  // Confirm deletion
  const confirmDelete = () => {

    setSelectedMarkets((prev) => prev.filter((m) => m.name !== marketToDelete));
    setDeleteModalVisible(false);
    setMarketToDelete(null);
  };

  const foodAndBeverages = [
    'Bars',
    'Snacking',
    'None',
    'Ready To Mix Beverages',
    'Replacement Meals',
    'RTD Beverages',
    'Other',
  ];

  const beautyAndSkin = [
    "Skincare",
    "Hair Care",
    "Body Care",
    "Wellness & Inner Beauty",
    "Dermatology & Treatments"
  ];
  const healthSupplements = [
    "Vitamins & Minerals", "Sports & Fitness Supplements", "Men’s Health",
    "Digestive Health", "Herbal & Natural Supplements", "Weight Management",
    "Mental Health & Sleep Support", "Heart & Cardiovascular Health",
    "Immune Support & Wellness", "Women’s Health", "Other"
  ];
  const petNutrition = [
    "Dental",
    "Food",
    "Supplements",
    "Snacking",
    "Other"
  ];
  const keyChannelCoverage = [
    "Offline Retail",
    "Online",
    "None",
    "Food Service/Out of Home"
  ];
  const keyCapabilities = [
    "Regulatory Compliance",
    "Importation & Clearance",
    "Warehousing",
    "Distribution",
    "Sales",
    "Marketing"
  ];
  const warehousing = [
    "Cold & Frozen",
    "Ambient",
  ];
  const businessmodels = [
    "Pre-Purchase",
    "Consignment",
    "Both",

  ];
  const tradingTerms = [
    "Exclusive",
    "Non-Exclusive",
    "Both",
  ];

  const marketing_investment = [
    "Partner Responsibility",
    "Brand Responsibility",
    "Co - Responsibility",
  ];
  const minimumExclusivityTenure = [
    "3 yrs or more",
    "2 yrs",
    "1 yr",
  ];
  const paymentTerms = [
    "Escrow",
    "COD",
    "Bank LC",
    "30-60 Days Credit",
  ];





  const [marketToDelete, setMarketToDelete] = useState<string | null>(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const handleDeleteClick = (marketName: string) => {
    setMarketToDelete(marketName);
    setDeleteModalVisible(true);

  };
  const [searchTerm, setSearchTerm] = useState<string>("");
  const { customOptionsMap, setCustomOptionsMap } = usePartnerOnboarding();
  const [activeMarket, setActiveMarket] = useState<string>(selectedMarkets[0]?.name || "");
  useEffect(() => {
    const marketData = selectedMarkets.find((m) => m.name === activeMarket);
    if (marketData) {
      setServiceScope(marketData.serviceScope);
    }
  }, [activeMarket, selectedMarkets]);
  const updateMarketServiceCapabilities = (
    activeMarket: string,
    category: keyof PartnerMarketType,
    subCategories: string[] | string,
    setData: React.Dispatch<React.SetStateAction<PartnerType>>
  ) => {
    setData((current) => {
      const currentMarkets = current.markets || {};

      const existingMarket = currentMarkets[activeMarket] || {
        focus_categories: new Map<string, string[]>(), // or convert this to a plain object too
        region: 0,
        channel_coverage: [],
        service_capabilities: [],
        warehousing: [],
        engagement_model: [],
        trading_terms: '',
        minimum_tenure: '',
        trade_marketing_investments: '',
        payment_terms: [],
      };

      const matchedMarket = selectedMarkets.find((m) => m.name === activeMarket);
      const regionId = matchedMarket?.id ?? 0;

      const updatedMarket = {
        ...existingMarket,
        [category]: subCategories,

        region: Number(regionId)
      };

      return {
        ...current,
        markets: {
          ...currentMarkets,
          [activeMarket]: updatedMarket,
        },
      };
    });
  };
  const updateMarketData = (marketName: string, newScope: Partial<any>) => {
    setSelectedMarkets((prev) =>
      prev.map((market) =>
        market.name === marketName
          ? {
            ...market,
            serviceScope: {
              ...market.serviceScope,
              ...newScope,
            },
          }
          : market
      )
    );
  };







  const filteredMarkets = selectedMarkets.filter((market) =>
    market.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const items = filteredMarkets.map((market, index) => ({
    key: (index + 1).toString(),
    label: (
      <div className="flex flex-row items-between justify-between ">

        <div className="flex items-center">
          <span>{market.name}</span>
          <span className="ml-2 bg-gray-200 text-gray-600 text-xs px-2 py-1 rounded-full">
            {`${Object.values(market.serviceScope).filter(
              (arr) => Array.isArray(arr) && arr.length > 0
            ).length}`.padStart(2, '0')}
          </span>

        </div>
        <div
          onClick=

          {() => handleDeleteClick(market.name)}

          className="items-center justify-center w-6 h-6  rounded-full hover:bg-gray-100 p-1"
        >
          {/* <DeleteOutlined className="text-[#667085] text-[12px]" /> */}
          <DeleteIconV2 />
        </div>
      </div>
    ),
    children: (
      <div className="space-y-6">
        <p className="common-title">Focus Category</p>
        <MultiSelectWithAddItem
        customOptionsMap={customOptionsMap}
          setCustomOptionsMap={setCustomOptionsMap}
          activeMarket={activeMarket}

          label="Health Supplements"
          contextKey="healthSupplements"
          options={healthSupplements}
          showAddCustom
          selected={
            data.markets[activeMarket]?.focus_categories?.["Health Supplements"] || []
          }
          setSelected={(val) => {
            // setServiceScope((prev) => ({ ...prev, healthSupplements: val }))
            // updateMarketData(activeMarket, { healthSupplements: val })

            updateMarketFocusCategory(
              activeMarket,
              "Health Supplements",
              val,
              setData
            );





          }
          }
          checked={checkedHealthSuppliments}
          setChecked={setCheckedHealthSuppliments}
          showCheckBox={true}
        />
        {/* Beauty & Skin */}
        <MultiSelectWithAddItem
         customOptionsMap={customOptionsMap}
         setCustomOptionsMap={setCustomOptionsMap}
          activeMarket={activeMarket}
          showAddCustom
          label="Beauty & Skin"
          contextKey="beautyAndSkin"
          options={beautyAndSkin}
          selected={data.markets[activeMarket]?.focus_categories?.["Beauty & Skin"] || []
          }
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, beautyAndSkin: val }))
            updateMarketData(activeMarket, { beautyAndSkin: val })
            updateMarketFocusCategory(
              activeMarket,
              "Beauty & Skin",
              val,
              setData
            );
          }
          }
          checked={checkedBeauty}
          setChecked={setCheckedBeauty}
          showCheckBox={true}
        />
        {/* Functional Food & Beverages */}
        <MultiSelectWithAddItem
         customOptionsMap={customOptionsMap}
         setCustomOptionsMap={setCustomOptionsMap}
          activeMarket={activeMarket}

          showAddCustom
          label="Functional Food & Beverages"
          contextKey="functionalFoodAndBeverages"
          options={foodAndBeverages}
          selected={data.markets[activeMarket]?.focus_categories?.["Functional Food & Beverages"] || []}
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, foodAndBeverages: val }))
            updateMarketData(activeMarket, { foodAndBeverages: val })
            const updated = val.map((m) => m === "Other" ? otherInputValueFAB : m);
            updateMarketFocusCategory(
              activeMarket,
              "Functional Food & Beverages",
              updated,
              setData
            );
          }
          }
          checked={checkedFood}
          setChecked={setCheckedFood}
          otherInputValue={otherInputValueFAB}
          setOtherInputValue={setOtherInputValueFAB}

        />
        {/* Pet Nutrition */}
        <MultiSelectWithAddItem
         customOptionsMap={customOptionsMap}
         setCustomOptionsMap={setCustomOptionsMap}
          activeMarket={activeMarket}

          showAddCustom
          label="Pet Nutrition"
          contextKey="petNutrition"
          options={petNutrition}
          selected={data.markets[activeMarket]?.focus_categories?.["Pet Nutrition"] || []}
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, petNutrition: val }))
            updateMarketData(activeMarket, { petNutrition: val })
            updateMarketFocusCategory(
              activeMarket,
              "Pet Nutrition",
              val,
              setData
            );
          }
          }
          checked={checkedPetNutrition}
          setChecked={setCheckedPetNutrition}
        />
        <Divider className=" !border-[#d0d5dd] !pY-8"></Divider>
        <p className="common-title">Channel & Capabilities</p>

        <MultiSelectWithAddItem
         customOptionsMap={customOptionsMap}
         setCustomOptionsMap={setCustomOptionsMap}
          activeMarket={activeMarket}
          label="Key Channel Coverage"
          contextKey="keyChannelCoverage"
          options={keyChannelCoverage}
          selected={data.markets[activeMarket]?.channel_coverage ?? []}
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, keyChannelCoverage: val }))
            updateMarketData(activeMarket, { keyChannelCoverage: val })
            updateMarketServiceCapabilities(activeMarket, "channel_coverage", val, setData)
          }
          }
          checked={true}
          setChecked={() => { }}
          showCheckBox={false}
        />


        <MultiSelectCheckboxGroup
          label="Key Capabilities"
          options={keyCapabilities}
          selected={data.markets[activeMarket]?.service_capabilities || []}
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, keyCapabilities: val }))
            updateMarketData(activeMarket, { keyCapabilities: val })
            updateMarketServiceCapabilities(activeMarket, "service_capabilities", val, setData)

          }
          }
          checked={true}
          showCheckBox={false}
          setChecked={() => { }}


        />
        <MultiSelectCheckboxGroup
          label="Warehousing"
          options={warehousing}
          selected={data.markets[activeMarket]?.warehousing || []}
          setSelected={(val) => {
            setServiceScope((prev: any) => ({ ...prev, warehousing: val }))
            updateMarketData(activeMarket, { warehousing: val })
            updateMarketServiceCapabilities(activeMarket, "warehousing", val, setData)

          }
          }
          checked={true}
          showCheckBox={false} setChecked={() => { }}


        />
        <Divider className=" !border-[#d0d5dd] !pY-8"></Divider>
        <p className="common-title">Engagement Terms</p>

        {/* Accepted Business Models  */}
        <SimpleSingleSelectButtonGroup
          label="Accepted Business Models"
          options={businessmodels}
          selectedValue={
            String(data.markets[activeMarket]?.engagement_model) || ""
          } showRadioButton={true}

          setSelectedValue={(val) => {

            setServiceScope((prev: any) => ({
              ...prev,
              acceptedBusinessModels: [val],
            }));
            updateMarketData(activeMarket, { acceptedBusinessModels: [val] });
            updateMarketServiceCapabilities(activeMarket, "engagement_model", String(val), setData)

          }}

        />  {/* Trading Terms*/}
        <SimpleSingleSelectButtonGroup
          label="Trading Terms"
          options={tradingTerms}
          selectedValue={String(data.markets[activeMarket]?.trading_terms || "")}
          showRadioButton={true}
          setSelectedValue={(val) => {
            const valueAsString = String(val); // Cast number to string
            setServiceScope((prev: any) => ({
              ...prev,
              tradingTerms: [valueAsString],
            }));
            updateMarketData(activeMarket, { tradingTerms: [valueAsString] });
            updateMarketServiceCapabilities(activeMarket, "trading_terms", val, setData)

          }}

        />


        {/* Minimum Exclusivity Tenure */}
        < SimpleSingleSelectButtonGroup
          label="Minimum Exclusivity Tenure"
          options={minimumExclusivityTenure}
          selectedValue={String(data.markets[activeMarket]?.minimum_tenure) || ""}
          showRadioButton={true}
          setSelectedValue={(val) => {
            const valueAsString = String(val); // Cast number to string
            setServiceScope((prev: any) => ({
              ...prev,
              minimumExclusivityTenure: [valueAsString],
            }));
            updateMarketData(activeMarket, { minimumExclusivityTenure: [valueAsString] });
            updateMarketServiceCapabilities(activeMarket, "minimum_tenure", val, setData)

          }}

        />
        {/* Preference on Marketing Investment */}
        < SimpleSingleSelectButtonGroup
          label="Preference on Marketing Investment"
          options={marketing_investment}
          selectedValue={String(data.markets[activeMarket]?.trade_marketing_investments || "")}
          showRadioButton={true}
          setSelectedValue={(val) => {
            const valueAsString = String(val); // Cast number to string
            setServiceScope((prev: any) => ({
              ...prev,
              preferenceonMarketingInvestment: [valueAsString],
            }));
            updateMarketData(activeMarket, { preferenceonMarketingInvestment: [valueAsString] });
            updateMarketServiceCapabilities(activeMarket, "trade_marketing_investments", val, setData)

          }}

        />
        {/* Payment Terms */}
        < SimpleSingleSelectButtonGroup
          label="Payment Terms"
          options={paymentTerms}
          selectedValue={String(data.markets[activeMarket]?.payment_terms || "")}
          showRadioButton={true}
          setSelectedValue={(val: string | string[]) => {
            const valueAsString = String(val); // Cast number to string
            setServiceScope((prev: any) => ({
              ...prev,
              paymentTerms: [valueAsString],
            }));
            updateMarketData(activeMarket, { paymentTerms: [valueAsString] });
            updateMarketServiceCapabilities(activeMarket, "payment_terms", val, setData)

          }}

        />


      </div>
    ),
  }));

  return (
    <div className="w-full ">
      <div className="w-full max-w-[686px]">
        <div className="common-title pb-[12px]">Service & Scope</div>
        <div className="common-sub-text pb-[60px]">Define your offerings and agree on the way we’ll partner.</div>
      </div>
      <Input
        placeholder="Search Markets"
        allowClear
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        prefix={<SearchOutlined style={{ color: "#667085" }} />}
        className="mb-4 rounded-[8px] px-3 py-3 text-sm border-[#d0d5dd]"
      />

      <div className="block md:hidden">

        {
          <Collapse items={items} defaultActiveKey={['1']} accordion expandIconPosition="right" className="rounded-[8px]"
            onChange={(key) => {
              const index = Number(key) - 1;
              const market = selectedMarkets[index];
              if (market) {
                setActiveMarket(market.name);
              }
            }}
            expandIcon={({ isActive }) => isActive ? <ChevronUp width={20} height={20} color="#667085" /> : <ChevronDown width={20} height={20} color="#667085" />}
          />
        }


      </div>

      <DeleteConfirmationModal
        open={deleteModalVisible}
        onCancel={() => setDeleteModalVisible(false)}
        onConfirm={confirmDelete}
      />

    </div>
  );
};

export default ExpansionEdgePage;
